var _path, _mask, _g, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlothInvitationExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 179,
    viewBox: "0 0 189 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89 178.3C138.153 178.3 178 138.454 178 89.3003C178 40.1469 138.153 0.300293 89 0.300293C39.8467 0.300293 0 40.1469 0 89.3003C0 138.454 39.8467 178.3 89 178.3Z",
    fill: "#0B0251"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 178,
    height: 179
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89 178.3C138.153 178.3 178 138.454 178 89.3003C178 40.1469 138.153 0.300293 89 0.300293C39.8467 0.300293 0 40.1469 0 89.3003C0 138.454 39.8467 178.3 89 178.3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-11 135.981L34.4796 129.035L101.394 111.222L176.495 99.7672H162.135L168.454 87.9395L159.009 99.7672H91.1049L35.4874 111.222L-11 101.807V135.981Z",
    fill: "#271795"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-9.3787 107.153C-9.4716 108.639 -8.44925 109.963 -6.98856 110.25L33.3981 118.167C34.9037 118.462 36.457 118.406 37.9375 118.004L93.6337 102.857L160.086 101.042L160.76 99.8554L162.707 96.4315L159.498 100.662L91.1049 101.042L36.8487 112.854C35.9514 113.049 35.0229 113.052 34.1243 112.862L-5.80528 104.436C-7.57597 104.062 -9.26576 105.347 -9.3787 107.153Z",
    fill: "#3B24DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.01 143.427L70.6063 100.755L72.1915 103.653L55.1405 107.255L35.4874 111.222C35.4874 111.222 24.2826 104.956 21.9081 95.0022C19.5335 85.048 29.1821 72.4853 29.1821 72.4853C29.1821 72.4853 30.0071 65.0591 39.1967 65.0591C48.3863 65.0591 85.5339 81.9705 85.5339 81.9705L133.568 72.4688C133.568 72.4688 151.394 75.124 154.377 87.9395C157.359 100.755 147.128 110.85 147.128 110.85C147.128 110.85 146.516 124.022 148.592 130.632C150.668 137.243 156.485 143.427 156.485 143.427L124.027 107.483L123.472 104.42L112.439 99.9643H97.6221C97.6221 99.9643 91.9172 111.052 93.0176 119.929C94.118 128.806 103.01 143.427 103.01 143.427Z",
    fill: "#DCAB8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6063 100.724C70.6063 100.724 72.6017 119.678 79.2709 128.124C84.7006 135 97.8963 140.823 102.614 142.75C103.131 142.961 103.599 142.375 103.289 141.911C100.633 137.939 93.7412 127.044 93.0176 119.929C92.4798 114.641 94.179 107.788 98.1151 99.3685C98.5633 98.4098 99.5467 96.4315 99.5467 96.4315",
    fill: "#DCAB8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.604 111.96C154.279 105.437 156.875 96.0221 154.377 87.9395C150.017 73.8343 141.309 72.4688 133.568 72.4688C125.828 72.4688 78.2741 83.8434 78.2741 83.8434",
    fill: "#DCAB8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.439 99.399L123.216 104.978C123.216 104.978 122.125 113.654 131.579 127.405C141.033 141.157 155.815 143.124 155.815 143.124C155.815 143.124 150.287 135.073 148.253 128.597C146.219 122.121 146.522 118.608 146.522 118.608C146.522 118.608 146.778 114.313 147.693 111.96C148.608 109.607 151.514 105.769 151.514 105.769",
    fill: "#DCAB8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.0651 85.5876C84.0651 85.5876 117.986 76.9469 102.413 78.2241C95.7727 78.7688 85.4899 78.3948 75.3977 75.1412C69.7119 73.3082 58.6131 66.8534 58.6131 66.8534C58.6131 66.8534 53.2405 63 45.8354 63C38.4302 63 32.0745 66.8534 32.0745 66.8534",
    fill: "#DCAB8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0745 66.8534C32.0745 66.8534 18.1165 78.1919 20.9765 93.457C23.8364 108.722 35.4874 111.222 35.4874 111.222L38.4179 110.645",
    fill: "#DCAB8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2833 63.3593C26.2833 63.3593 25.222 66.3404 26.8182 68.0897C28.4143 69.839 31.5261 69.839 31.5261 69.839",
    stroke: "#3B24DD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5261 69.839C31.5261 69.839 29.8407 67.0229 29.6885 65.5696C29.5363 64.1164 30.6317 61.3003 30.6317 61.3003",
    stroke: "#3B24DD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4179 110.645C38.4179 110.645 34.5914 109.366 31.4024 106.107C27.6443 102.266 27.2752 98.151 26.993 95.7432C26.3942 90.633 28.6447 87.0516 32.0745 85.8574C35.5042 84.6632 39.0899 85.2592 42.9075 83.3438C46.7251 81.4283 51.5504 74.875 55.382 74.2423C59.2135 73.6096 63.3089 75.6513 65.9425 79.2633C67.2758 81.0918 70.1845 83.2209 69.8494 90.8082C69.5143 98.3956 53.9601 107.533 53.9601 107.533L38.4179 110.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7231 99.7716C27.7231 99.7716 32.1857 92.0305 38.2937 91.2794C44.4016 90.5283 45.7218 94.9956 45.7218 97.4398C45.7218 98.203 45.4508 100.307 43.6982 101.907C42.3687 103.121 39.7431 103.552 38.2937 105.725C37.5747 106.803 38.4179 110.645 38.4179 110.645C38.4179 110.645 34.5485 109.369 31.4025 106.107C28.2564 102.845 27.7231 99.7716 27.7231 99.7716Z",
    fill: "#271795"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5005 98.4787C51.4923 98.5604 51.4025 98.6066 51.3313 98.5657L48.5659 96.9777C48.4882 96.9331 48.4905 96.8203 48.5699 96.7789L51.6527 95.1727C51.7326 95.1311 51.8268 95.1948 51.8179 95.2844L51.5005 98.4787Z",
    fill: "#0B0251",
    stroke: "#0B0251",
    strokeWidth: 1.13314,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4831 98.6529C51.4831 98.6529 51.5245 100.667 51.0918 101.518C50.6591 102.37 49.3465 102.857 49.3465 102.857",
    stroke: "#0B0251",
    strokeWidth: 1.13314,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.122 98.6529C34.122 98.6529 35.9297 101.727 37.997 100.846C40.0642 99.9643 38.5695 96.4315 38.5695 96.4315",
    stroke: "#0B0251",
    strokeWidth: 1.13314,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5932 80.0582C66.5932 80.0582 65.6507 80.6169 65.0732 80.7051C59.6804 81.5289 56.7301 81.1 54.5537 82.6332C52.5908 84.0161 50.2267 85.8188 51.4087 89.6686C52.5908 93.5184 55.4169 93.9952 56.2391 94.1534C59.2096 94.7247 61.7988 92.7261 65.0732 92.7261C68.3476 92.7261 69.1077 94.1534 69.1077 94.1534C69.1077 94.1534 70.6275 91.5088 69.8761 86.9072C69.1246 82.3055 66.5932 80.0582 66.5932 80.0582Z",
    fill: "#271795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4831 98.6529C51.4831 98.6529 52.8671 99.7113 53.8948 99.9098C54.9224 100.108 56.3064 99.5845 56.3064 99.5845",
    stroke: "#0B0251",
    strokeWidth: 1.13314,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2899 87.0623C57.2899 87.0623 59.0781 90.4854 61.3324 89.0379C63.5867 87.5904 61.7788 84.3463 61.7788 84.3463",
    stroke: "#0B0251",
    strokeWidth: 1.13314,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8542 133.856C85.8542 133.856 88.3337 131.765 90.1461 130.945C91.9584 130.126 95.7372 129.726 95.7372 129.726L100.754 138.127L103.865 142.743C104.016 142.967 103.8 143.253 103.544 143.166C101.78 142.57 97.4463 141.066 94.93 139.846C91.7149 138.286 85.8542 133.856 85.8542 133.856Z",
    fill: "white",
    stroke: "#D89976",
    strokeWidth: 0.566572
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.216 134.639C138.216 134.639 140.833 131.729 142.875 130.873C144.918 130.016 148.592 130.352 148.592 130.352L156.069 142.881C156.22 143.134 156.056 143.45 155.762 143.455C154.461 143.476 151.338 143.355 148.144 141.941C143.958 140.087 138.216 134.639 138.216 134.639Z",
    fill: "white",
    stroke: "#D89976",
    strokeWidth: 0.566572
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.1049 130.632C91.1049 130.632 94.2444 133.929 96.122 135.388C97.9997 136.846 103.486 142.947 103.486 142.947",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1049 130.632C91.1049 130.632 94.2444 133.929 96.122 135.388C97.9997 136.846 103.486 142.947 103.486 142.947",
    stroke: "#D89976",
    strokeWidth: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6278 131.982C88.6278 131.982 92.8471 136.383 95.4708 138.127C98.0944 139.871 103.09 142.503 103.09 142.503",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6278 131.982C88.6278 131.982 92.8471 136.383 95.4708 138.127C98.0944 139.871 103.09 142.503 103.09 142.503",
    stroke: "#D89976",
    strokeWidth: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.863 132.36C140.863 132.36 144.575 136.495 148.144 138.761C151.714 141.027 155.815 143.124 155.815 143.124",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.863 132.36C140.863 132.36 144.575 136.495 148.144 138.761C151.714 141.027 155.815 143.124 155.815 143.124",
    stroke: "#D89976",
    strokeWidth: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.294 130.727C143.294 130.727 147.021 133.774 148.912 135.291C150.803 136.808 155.7 142.997 155.7 142.997",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.294 130.727C143.294 130.727 147.021 133.774 148.912 135.291C150.803 136.808 155.7 142.997 155.7 142.997",
    stroke: "#D89976",
    strokeWidth: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.8246 99.9643C97.8246 99.9643 96.3115 103.439 95.644 105.237C94.9765 107.035 94.0998 109.999 94.0998 109.999C94.0998 109.999 93.7737 101.793 95.644 97.61C96.7943 95.0374 99.9914 93.7086 100.754 93.5437C104.046 92.8313 124.478 93.158 129.74 96.8644C135.001 100.571 128.487 107.635 129.74 113.962C130.233 116.452 130.672 119.84 132.139 124.05C133.157 126.97 136.572 133.454 136.572 133.454C136.572 133.454 135.322 132.201 134.751 131.541C130.882 127.067 127.937 122.338 125.812 117.462C125.568 116.901 125.005 115.678 124.81 115.142C122.62 109.131 123.216 104.978 123.216 104.978L112.439 99.9643H97.8246Z",
    fill: "black",
    fillOpacity: 0.346673
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9601 107.533C53.9601 107.533 57.1281 105.66 59.1964 104.243C59.6003 103.967 60.4527 103.294 61.5141 102.49C62.2085 101.964 62.8094 101.45 63.7048 100.713C63.8881 100.562 64.5219 99.9957 65.1089 99.3895C65.5058 98.9797 66.0159 98.5101 66.4621 97.9806C68.5797 95.4672 71.1578 92.0657 74.3198 92.3866C78.1479 92.7751 73.1933 100.547 74.0319 109.186C74.563 114.657 76.5831 123.972 76.5831 123.972C76.5831 123.972 75.6595 122.046 75.2794 121.138C74.3477 118.913 73.683 116.908 73.1656 115.122C72.2337 111.905 70.9108 104.01 70.9108 104.01L53.9601 107.533Z",
    fill: "black",
    fillOpacity: 0.346673
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.999 141.941C103.761 140.924 91.2287 129.446 88.8819 125.381C86.535 121.316 83.3438 116.075 81.5823 117.091C79.8209 118.108 81.5851 128.304 83.932 132.369C86.2788 136.434 100.238 142.958 101.999 141.941Z",
    fill: "black",
    fillOpacity: 0.119892
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.759 120.774C146.491 120.421 146.147 113.736 147.285 111.673C148.423 109.611 148.924 109.814 149.82 108.71C151.895 106.152 153.033 103.663 153.567 102.66C153.81 102.203 155.118 97.9409 155.296 95.0021C155.405 93.2009 154.699 91.9574 154.209 92.2145C152.961 92.8686 152.146 97.7467 149.82 101.777C147.959 105.001 144.468 107.514 143.92 108.142C141.981 110.368 145.026 121.127 145.759 120.774Z",
    fill: "black",
    fillOpacity: 0.119892
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.567 99.8786C164.567 99.8786 170.689 95.0367 176.858 94.8683C183.027 94.6999 188.358 100.721 188.358 100.721C188.358 100.721 183.132 105.299 178.191 105.438C173.25 105.578 164.567 99.8786 164.567 99.8786Z",
    fill: "#0CA068"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.403 94.2187C163.403 94.2187 161.228 89.2359 164.167 83.8088C167.106 78.3818 174.985 76.7759 174.985 76.7759C174.985 76.7759 176.337 83.5909 173.988 87.9395C171.638 92.2881 163.877 96.4315 163.877 96.4315C163.877 96.4315 163.963 95.4222 163.877 95.0239C163.792 94.6256 163.403 94.2187 163.403 94.2187Z",
    fill: "#0CA068"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.03 92.3059C165.744 90.6366 166.357 89.3561 166.869 88.4643C167.937 86.603 171.931 81.0374 171.931 81.0374",
    stroke: "#271795",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3397 60.476L62.0036 58.8748C61.0625 58.637 60.978 57.3328 61.8805 56.9755L69.1045 54.1158C70.0085 53.7579 69.9218 52.451 68.9785 52.2157L63.3077 50.801",
    stroke: "#3B24DD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4659 35.3003L63.0976 34.017C62.6449 33.884 62.6114 33.2557 63.0473 33.0752L68.8399 30.678C69.2692 30.5003 69.2452 29.8841 68.8033 29.7405L63.9341 28.1571",
    stroke: "#3B24DD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0291 22.3003L79.9073 21.2894C79.4529 21.1422 79.4437 20.5028 79.8937 20.3426L84.0676 18.8571C84.5083 18.7002 84.5115 18.0782 84.0725 17.9167L80.9342 16.7628",
    stroke: "#3B24DD",
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlothInvitationExpired);
export default __webpack_public_path__ + "static/media/sloth_invitation_expired.a79f1fb85ef001523e62f98e6c9152a4.svg";
export { ForwardRef as ReactComponent };